module.exports = __webpack_public_path__ + "static/media/newform.725b9d89.png";